<content-loading *ngIf="isLoading"></content-loading>
<form autocomplete="off" class="form mx-4" style="padding-top: 10px">
  <div class="columns">
    <div class="column is-7">
      <form-preview
        [isReadonly]="isReadonly"
        [rows]="activeForm"
        [values]="evalJson"
        [activeForm]="activeForm"
        *ngIf="activeForm && evalJson"
        (onSelect)="handleSelectChange($event)"
        (onSelectInput)="handleSelectInput($event)"
        (onInput)="handleFieldChange($event)"
      ></form-preview>
    </div>
    <div class="column is-5">
      <property-invoice
        [data]="calculations"
        [propertyDetails]="state"
        [activeForm]="activeForm"
        [isLoading]="isFeaturesCalculating | async"
        (onReport)="report($event)"
        [isPropertyReportGenerating]="isPropertyReportGenerating | async"
        [dynamicFieldsTranslation]="dynamicFieldsTranslation"
      >
      </property-invoice>
    </div>
  </div>
</form>
